<template>
  <div>
    <el-dialog
      :title="title"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="1000px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <section class="dialogContent">
        <qx-search-box
          class="searchBox"
          ref="searchBox"
          :searchBoxData="searchBoxData"
          @sub="sub"
          :inDialog="true"
          permpisionsQuery
          v-if="!noSearch"
        />
        <TableBox
          :isRadio="isRadio"
          ref="tableBox"
          :getListApi="getListApi"
          :tableTitle="tableTitle"
          :tableSelectTar="tableSelectTar"
          :fnRadioDisabled="fnRadioDisabled"
          :handleResParams="handleResParams"
        >
          <slot
            slot="tableSlot"
            name="tableSlot"
            slot-scope="scope"
            :column="scope.column"
            :row="scope.row"
          />
        </TableBox>
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button type="primary" @click="choose" :loading="subLoading">确定</el-button>
      </section>
    </el-dialog>
    <template v-if="isInput">
      <el-autocomplete
        class="norderFormWidth"
        v-model="resultVal[showName]"
        :placeholder="placeholder || ''"
        :disabled="disabled"
        :fetch-suggestions="querySearchAsync"
        :debounce="500"
        :value-key="valueKey || 'value'"
        @select="(val) => { onSelect && onSelect(val); }"
      >
        <span slot="suffix" class="inputSlotText cur primary" @click="showChooseDialog">选择</span>
      </el-autocomplete>
    </template>
    <template v-else>
      <div
        v-if="!customShow"
        class="chooseShowBox posire cur chooseContentClass"
        :class="{ active: Boolean(resultVal[showName]), disabled: disabled }"
        :title="isRadio ? resultVal[showName] || placeholder : placeholder"
        @click="showChooseDialog"
      >
        {{ isRadio ? resultVal[showName] || placeholder : placeholder }}
        <i
          class="el-icon-error posiab clearIcon"
          v-if="clearable && resultVal[showName]"
          @click.stop="clear"
        />
        <i class="el-icon-arrow-down posiab downIcon" />
      </div>
    </template>
    <div class="tableBox" v-if="!isRadio && resultVal.length > 0 && !customShow">
      <el-table :data="resultVal" tooltip-effect="dark">
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        />
        <el-table-column width="55" label="操作">
          <template slot-scope="scope">
            <span class="cur blur" @click="delCheckboxSelect(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  // model: {
  //   prop: 'resultVal', // 父级传进来的值
  //   event: 'change',
  // },
  props: {
    fnRadioDisabled: {
      type: Function,
    },
    handleResParams: {
      type: Function,
    },
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    noSearch: { // 没有搜索栏
      type: Boolean,
      default: false,
    },
    title: { // dialog title
      type: String,
      default: '选择模板',
    },
    resultVal: { // 选择结果
      default: '',
    },
    isRadio: { // 是否单选
      type: Boolean,
      default: false,
    },
    disabled: { // 禁用状态
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    otherSearchData: { // 请求列表接口时额外的参数
      type: Object,
      default: () => ({}),
    },
    searchBoxDataTmpl: { // 搜索栏
      type: Object,
      default: () => ({}),
    },
    showTableTitle: { // 展示结果table的渲染数据
      type: Array,
      default: () => ([]),
    },
    handleSearchData: { // 搜索数据处理
      type: Function,
    },
    getListApi: { // 列表接口
      type: Function,
    },
    tableTitle: { // dialog里table的title
      type: Array,
      default: () => ([]),
    },
    tableSelectTar: { // 列表唯一标识
      type: String,
    },
    showName: { // 选中值展示字段
      type: String,
    },
    isInput: {
      type: Boolean,
      default: false,
    },
    valueKey: {
      type: String,
    },
    querySearchAsync: {
      type: Function,
    },
    onSelect: {
      type: Function,
    },
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false,
      text: '',
      searchBoxData: this.searchBoxDataTmpl,
      tableData: {
        title: this.showTableTitle,
      },
    };
  },
  watch: {
    otherSearchData: function () {
      this.handleOtherSearchData();
    },
  },
  methods: {
    show () {
      this.showChooseDialog();
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (this.handleSearchData) {
        searchBoxData = this.handleSearchData(searchBoxData);
      }
      this.$refs.tableBox.saveSearchBoxData({
        ...this.otherSearchData,
        ...searchBoxData,
      });
    },
    showChooseDialog () {
      if (this.disabled) {
        return;
      }
      this.dialogFormVisible = true;
      this.$emit('beforeSub');
      if (this.$refs.searchBox) {
        this.$refs.searchBox.sub();
      }
      this.$nextTick(() => {
        this.$emit('show');
        this.$refs.tableBox.setSelectVal(this.resultVal);
      });
    },
    cancle () {
      this.$refs.tableBox.clearSelect();
      this.dialogFormVisible = false;
    },
    clear () {
      this.$emit('change', {});
    },
    choose () {
      if (this.isRadio) {
        this.$emit('change', this.$refs.tableBox.getSelectRadioData());
      } else {
        this.$emit('change', this.$refs.tableBox.getSelectData());
      }
      this.dialogFormVisible = false;
    },
    // 选择输入的项
    chooseSelectItem (item) {
      this.$emit('change', item);
    },
    delCheckboxSelect (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('change', this.resultVal);
    },
    handleOtherSearchData () {
      if (this.$refs.searchBox) {
        const formVal = this.$refs.searchBox.getVal();
        Object.keys(this.otherSearchData).forEach((key) => {
          if (formVal.hasOwnProperty(key)) {
            this.$refs.searchBox.setVal(key, this.otherSearchData[key]);
            delete this.otherSearchData[key];
          }
        });
      } else {
        Object.keys(this.otherSearchData).forEach((key) => {
          this.setFormAttrVal({
            form: this.searchBoxData,
            attr: 'default',
            value: this.otherSearchData[key],
            names: [key],
          });
        });
      }
    },
  },
  mounted () {
    this.handleOtherSearchData();
  },
};
</script>

<style scoped lang="scss">
.dialogContent {
  padding-bottom: 24px;
}
.searchBox {
  ::v-deep .customForm {
    margin: 0;
  }
}
::v-deep .el-radio-group {
  width: 100%;
}
.chooseShowBox {
  height: 32px;
  line-height: 32px;
  width: 240px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  padding: 0 15px;
  border-radius: 4px;
  color: #c0c4cc;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .clearIcon {
    font-size: 14px;
    right: 25px;
    top: 8px;
    color: #c0c4cc;
    display: none;
  }
  .downIcon {
    font-size: 14px;
    right: 5px;
    top: 8px;
    color: #c0c4cc;
  }
}
.chooseShowBox:hover {
  .clearIcon {
    display: block;
  }
}
.active {
  color: #333;
}
.disabled {
  background-color: #f5f7fa;
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>
